import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWrbModel } from "../wrbModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IWrbDetail } from "../wrbTypes";
import { formatNum } from "@/utils/utils";
import moment from "moment";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useWrbModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IWrbDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'realCode',
            fixed: "left",
            render: t => t === "listTotalAmount" ? "" : t
        },
        // {
        //     title: '报关单号',
        //     width: 160,
        //     dataIndex: 'code',
        //     fixed: "left",
        //     render: t => t === "listTotalAmount" ? "" : t
        // }, 
        {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '预警状态',
            width: 100,
            dataIndex: 'warningType',
            render: text => getTreeNodeName(text)
        }, {
            title: '币种',
            width: 160,
            dataIndex: 'currencyName',
        }, {
            title: '应收金额',
            width: 160,
            dataIndex: 'contractAmount',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '已收金额',
            width: 160,
            dataIndex: 'countPrice',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '未收金额',
            width: 160,
            dataIndex: 'uncollected',
            render: (t, r) => `${r.currency}${formatNum(t)}`,
            sorter: (a, b) =>b.uncollected - a.uncollected,
        }, {
            title: '信用证号',
            width: 80,
            dataIndex: "creditCode"
        }, {
            title: '收汇日期',
            width: 200,
            dataIndex: "settlementTime",
            ellipsis: true,
            render: t => moment(t).format("YYYY-MM-DD")
        }, {
            title: '出运日期',
            width: 180,
            dataIndex: 'shippingTime',
            ellipsis: true,
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
            
        }, {
            title: '预计收款日期',
            width: 200,
            dataIndex: 'estimatedTime',
            ellipsis: true,
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '逾期天数',
            width: 100,
            dataIndex: 'dataNum',
        },
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
